/**
 * Who may trigger a report rebuild.
 *
 * Mirrors wsr-api's `ReportRebuildController` @PreAuthorize gate
 * (OWNER, ADMIN, SUPER_ADMIN — never STAFF). Keep the two in step: if the server
 * gate changes, change this set, not a call site.
 */
export const REPORT_REBUILD_ROLES: readonly string[] = ['OWNER', 'ADMIN', 'SUPER_ADMIN'];

export function canRebuildReports(roles: readonly string[] | undefined): boolean {
  if (!roles) return false;
  return roles.some((role) => REPORT_REBUILD_ROLES.includes(role));
}
